import { Segment } from 'semantic-ui-react';
import styled from '@emotion/styled';

import {
  CertificationStatus,
  CertificationStatusWithDates,
  ExaminerCertificationStatusesDto,
  ExaminerCertificationStatusWithDates,
} from 'api';
import { ExaminerStatusLabel } from './ExaminerStatusLabel';

type ExaminerStatuses =
  | ExaminerCertificationStatusesDto
  | ExaminerCertificationStatusWithDates
  | CertificationStatusWithDates;

type ExaminerStatusLabelsProps = {
  template?: 'label' | 'shortLabel';
  examinerStatuses: ExaminerStatuses | undefined;
};

export const ExaminerStatusLabels = ({ template, examinerStatuses }: ExaminerStatusLabelsProps) => {
  if (!examinerStatuses) {
    return null;
  }

  return (
    <S.Segment basic noPadding={template != 'label'}>
      <ExaminerStatusLabel
        text="Speaking Status - "
        testId="examiner-status-speaking"
        status={examinerStatuses.speakingCertificationStatus}
        nextCertificationDate={examinerStatuses.nextSpeakingCertificationDate}
        iconName="comment"
        template={template}
      />
      <ExaminerStatusLabel
        text="Online Speaking Status - "
        testId="examiner-status-online-speaking"
        status={examinerStatuses.onlineSpeakingStatus}
        nextCertificationDate={
          examinerStatuses.onlineSpeakingStatus === CertificationStatus.NotYetCertified
            ? null
            : examinerStatuses.nextSpeakingCertificationDate
        }
        iconName="desktop"
        template={template}
      />
      <ExaminerStatusLabel
        text="Writing Status - "
        testId="examiner-status-writing"
        status={examinerStatuses.writingCertificationStatus}
        nextCertificationDate={examinerStatuses.nextWritingCertificationDate}
        iconName="pencil alternate"
        template={template}
      />
      <ExaminerStatusLabel
        text="A1 Status - "
        testId="examiner-status-a1"
        status={examinerStatuses.a1LifeSkillCertificationStatus}
        nextCertificationDate={examinerStatuses.nextA1LifeSkillsCertificationDate}
        label="A1"
        template={template}
      />
      <ExaminerStatusLabel
        text="A2 Status - "
        testId="examiner-status-a2"
        status={examinerStatuses.a2LifeSkillCertificationStatus}
        nextCertificationDate={examinerStatuses.nextA2LifeSkillsCertificationDate}
        label="A2"
        template={template}
      />
      <ExaminerStatusLabel
        text="B1 Status - "
        testId="examiner-status-b1"
        status={examinerStatuses.b1LifeSkillCertificationStatus}
        nextCertificationDate={examinerStatuses.nextB1LifeSkillsCertificationDate}
        label="B1"
        template={template}
      />
    </S.Segment>
  );
};

const S = {
  Segment: styled(Segment, { shouldForwardProp: (prop) => prop !== 'noPadding' })<{
    noPadding?: boolean;
  }>`
    text-align: center;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    &.ui.segment {
      padding: ${(props) => (props.noPadding ? '0' : 'initial')};
    }

    & > .label {
      margin-bottom: 10px;
    }
  `,
};
